import moment from "moment";

/**
 * Formatea fechas de manera flexible, manteniendo compatibilidad con formatos existentes
 * 
 * @param {string} date - La fecha a formatear
 * @param {string} outputFormat - Formato de salida (por defecto "DD/MM/YYYY")
 * @returns {string} - Fecha formateada o '-' si no hay fecha
 * 
 * Ejemplos:
 * - formatDate("20250115") → "15/01/2025"
 * - formatDate("15/01/2025") → "15/01/2025" (mantiene formato existente)
 * - formatDate(null) → "-"
 */
export const formatDate = (date, outputFormat = "DD/MM/YYYY") => {
    if (!date) return '-';

    const str = String(date);

    // Si la fecha ya está en formato DD/MM/YYYY, mantenerla así (cuando coincide con el output deseado)
    if (str.includes('/') && outputFormat === "DD/MM/YYYY") {
        return str;
    }
    if (str.includes('/')) {
        return moment(str, "DD/MM/YYYY").format(outputFormat);
    }

    // ISO (2026-03-15T... o 2026-03-15) — guion en posición 5 indica YYYY-MM-DD
    if (str.includes('-') && str.length >= 10) {
        return moment(str.slice(0, 10), "YYYY-MM-DD").format(outputFormat);
    }

    // Si está en formato YYYYMMDD, convertirla al formato deseado
    return moment(str, "YYYYMMDD").format(outputFormat);
};

/**
 * Convierte una fecha a formato YYYYMMDD para almacenamiento
 * 
 * @param {string|Date} date - La fecha a convertir
 * @returns {string} - Fecha en formato YYYYMMDD
 */
export const formatDateForStorage = (date) => {
    if (!date) return '';
    
    // Si ya está en formato YYYYMMDD, devolverla tal como está
    if (typeof date === 'string' && date.length === 8 && !date.includes('/')) {
        return date;
    }
    
    // Convertir a formato YYYYMMDD
    return moment(date).format("YYYYMMDD");
};

/**
 * Valida si una fecha está en formato válido
 * 
 * @param {string} date - La fecha a validar
 * @returns {boolean} - true si es válida, false si no
 */
export const isValidDate = (date) => {
    if (!date) return false;
    
    // Verificar formato DD/MM/YYYY
    if (date.includes('/')) {
        return moment(date, "DD/MM/YYYY", true).isValid();
    }
    
    // Verificar formato YYYYMMDD
    return moment(date, "YYYYMMDD", true).isValid();
};
